module.exports = __webpack_public_path__ + "cdc31cb23cb93be74d3f80b11bb3d754.png";